// eslint-disable-next-line
import Worker from "comlink-loader!./assetWorker"; // inline loader

export default Worker;
